import { ErrorResponse } from './common.types';

/** Определяет базовый адрес API с учетом локальной разработки на том же хосте. */
export function resolveApiBaseUrl(): string {
  const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim() ?? '';

  if (typeof window === 'undefined') {
    return configuredBaseUrl;
  }

  const isDevelopmentBuild = process.env.NODE_ENV === 'development';
  const runtimeBaseUrl = isDevelopmentBuild
    ? `${window.location.protocol}//${window.location.hostname}:4000`
    : '';

  if (!configuredBaseUrl) {
    return runtimeBaseUrl;
  }

  try {
    const configuredUrl = new URL(configuredBaseUrl, window.location.origin);

    if (isDevelopmentBuild && configuredUrl.hostname !== window.location.hostname) {
      configuredUrl.protocol = window.location.protocol;
      configuredUrl.hostname = window.location.hostname;
      configuredUrl.port = configuredUrl.port || '4000';
    }

    return `${configuredUrl.origin}${configuredUrl.pathname.replace(/\/$/, '')}`;
  } catch {
    return runtimeBaseUrl;
  }
}

const apiBaseUrl = resolveApiBaseUrl();

/** Собирает абсолютный путь API для fetch-запросов клиента. */
export function buildApiUrl(path: string): string {
  return `${apiBaseUrl}${path}`;
}

/** Безопасно читает JSON только из соответствующего ответа. */
export async function readJson<T>(response: Response): Promise<T | null> {
  const contentType = response.headers.get('content-type') ?? '';

  if (!contentType.includes('application/json')) {
    return null;
  }

  return response.json() as Promise<T>;
}

/** Проверяет, что ответ сервера пришёл в стандартном формате ошибки API. */
export function isErrorResponse(payload: unknown): payload is ErrorResponse {
  return typeof payload === 'object' && payload !== null && 'error' in payload;
}